import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  LinearProgress,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
const AddRegularization = () => {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();

  const [id, setId] = useState(null);
  const { user, AccessData } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [regularizationData, setRegularizationData] = useState({
    requestedDate: new Date().toISOString().split("T")[0],
    checkIn: "",
    checkOut: "",
    reason: "",
    checkInStatus: "unchecked",
    checkOutStatus: "unchecked",
    reasonStatus: "unchecked",
  });

  const [originalRegularizationData, setOriginalRegularizationData] = useState({
    checkIn: "",
    checkOut: "",
    reason: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onRegularizationSubmit = async () => {
    setCirleLoading(true);
    const query = `
    mutation regularizationRequest($input: RegularizationApprovalInput!){  
    regularizationApproval(input: $input){  
      regularizationApproval{  
        id 
        checkIn 
        checkOut 
        reason 
        requestedDate 
        user{ 
          id 
          email 
        } 
        teamleaderId 
        status 
        teamApproval 
        hrApproval 
      }  
    message 
    success 
    error 
    } 
  }  
            `;

    const { checkIn, checkOut, reason } = regularizationData;

    try {
      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: {
            input: {
              userId: user?.id,
              checkIn: checkIn,
              checkOut: checkOut,
              reason: reason,
              teamleaderId: +user?.teamleader,
              screenName: "Regularization Approval",
            },
          },
        }),
      });

      const data = await response.json();
console.log("postdata",data);

      let Val = data.data.regularizationApprovalHR;

      if (Val !== null) {
        if (data.data.regularizationApprovalHR !== null) {
          navigate("/regularization-request");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Regularization Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else if (Val == null) {
        if (
          data.errors[0]?.message ==
          "Your regularization request overlaps with an existing pending or approved leave request."
        ) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: data.errors[0]?.message,
            showConfirmButton: false,
            timer: 5500,
          });
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      }
      setCirleLoading(false);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditRegularizationSubmit = async () => {
    setCirleLoading(true);

    const query = `
         mutation UpdateRegularizationApproval($input: RegularizationApprovalUpdateInput!) { 

  updateRegularizationApproval(input: $input) { 

    regularizationApproval { 

      id 

      checkIn 

      checkOut 

      reason 

      teamleaderId 

    } 

    message 

    success 

    error 

  } 

} 
        `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              id: id,
              checkIn: regularizationData.checkIn,
              checkOut: regularizationData.checkOut,
              reason: regularizationData.reason,
              teamleaderId: regularizationData.teamleaderId,
            },
          },
        }),
      });

      const responseData =
        response.data.data.updateRegularizationApproval.regularizationApproval;

      // Check if there's an error in the response data
      if (responseData.errors) {
        throw new Error(
          responseData.errors[0]?.message || "Something went wrong"
        );
      }

      console.log("responseEDIT:", responseData);

      if (responseData) {
        navigate("/regularization-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteRegularization();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteRegularization = async () => {
    setCirleLoading(true);
    const query = `
           mutation DeleteRegularizationApproval($id: ID!) { 

  deleteRegularizationApproval(id: $id) { 

    regularizationApproval { 

      id 

      checkIn 

      checkOut 

      reason 

      teamleaderId 

    } 

    message 

    success 

    error 

  } 

} 
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: +id,
        },
      });

      const responseData = response.data;

      if (responseData.data.deleteRegularizationApproval.success) {
        navigate("/regularization-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.log(
          "Error deleting Regularization:",
          responseData.data.deleteRegularizationApproval.message
        );
      }
      setCirleLoading(false);
    } catch (error) {
      setCirleLoading(false);
      console.error(
        "An error occurred while deleting the Regularization:",
        error
      );
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `
 query regularizationRequestById($id: String!){ 

  getRegularizationById(id: $id){ 

    data { 

      id 

      checkIn 

      checkOut 

      reason 

      status 

      teamleaderId 

      teamApproval 

      hrApproval 

      user{ 

        id 

        firstName 

        lastName 

        email 

      } 

      approvalStatus { 

        id 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

        status 

      } 

    } 

    success 

    error 

    message 

  } 

} 

 
             `;
    try {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const regularizationRowdata =
        response.data.data?.getRegularizationById?.data[0];

      setRegularizationData({
        requestedDate: regularizationRowdata?.requestedDate,
        checkIn: regularizationRowdata?.checkIn,
        checkOut: regularizationRowdata?.checkOut,
        reason: regularizationRowdata?.reason,
      });

      setOriginalRegularizationData({
        checkIn: regularizationRowdata?.checkIn,
        checkOut: regularizationRowdata?.checkOut,
        reason: regularizationRowdata?.reason,
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleAddRegularizationDatachange = (event) => {
    let regularizationState = { ...regularizationData };

    switch (event.target.name) {
      case "reason": {
        const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkIn": {
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
          regularizationState["checkOut"] = event.target.value;

          const dateOnly = event.target.value.split("T")[0];
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkOut": {
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }

    regularizationState[event.target.name] = event.target.value;

    setRegularizationData(regularizationState);
  };

  const handleAddRegularization = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onRegularizationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handlediscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardRegularization();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardRegularization = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setRegularizationData({
      checkIn: originalRegularizationData.checkIn,
      checkOut: originalRegularizationData.checkOut,
      reason: originalRegularizationData.reason,
    });
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      regularizationData.checkInStatus === "success" &&
      regularizationData.checkOutStatus === "success" &&
      regularizationData.reasonStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/regularization-request");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Regularization details for
                    you. This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view
                          ? "View Regularization"
                          : "Edit Regularization"}
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditRegularaization" &&
                          item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                            sx={{
                              "&:hover": {
                                backgroundColor: "none", // Keeps the original background color
                                boxShadow: "none", // Removes shadow
                              },
                            }}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Regularization
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Requested Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="requestedDate"
                      value={regularizationData.requestedDate}
                      readOnly
                      error={regularizationData.requesteddatestatus === "error"}
                      success={
                        regularizationData.requesteddatestatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        CheckIn <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkIn"
                      type="datetime-local"
                      value={regularizationData.checkIn}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkInStatus === "error"}
                      success={regularizationData.checkInStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      // inputProps={{
                      //   min: new Date(
                      //     new Date().setDate(new Date().getDate() - 7)
                      //   ) // 7 days before today
                      //     .toISOString()
                      //     .slice(0, 16), // Format as YYYY-MM-DDTHH:mm
                      // }}
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        CheckOut <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkOut"
                      type="datetime-local"
                      value={regularizationData.checkOut}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkOutStatus === "error"} // Update to check for checkout status
                      success={regularizationData.checkOutStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      // inputProps={{
                      //   min: new Date(new Date().setDate(new Date().getDate() - 7)) // 7 days before today
                      //     .toISOString()
                      //     .slice(0, 16),
                      // }}
                      inputProps={{
                        min: regularizationData.checkIn,
                      }}
                      // Update to check for checkout status
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Reason <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="reason"
                      // placeholder="eg. Reason"
                      value={regularizationData.reason}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.reasonStatus === "error"}
                      success={regularizationData.reasonStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={6}
                    />
                    {regularizationData.reasonStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Reason should be a minimum 10 characters maximum 100
                          characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Regularization data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={handlediscard}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    // disabled={
                    //     !checkFields() || pageState.state === "submitting"
                    // }
                    onClick={onEditRegularizationSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2, marginLeft: "4px" }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() || pageState.state === "submitting"
                    }
                    onClick={handleAddRegularization}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};
export default AddRegularization;
